import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { logRouteRequest } from '../../_models/route-logger/log-route-request.model';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';
import { SessionUserHashManagerService } from '../session-user-hash-manager/session-user-hash-manager.service';

@Injectable({
  providedIn: 'root'
})
export class RouteLoggingService extends BaseService {

  private endpoint: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient,
    protected hashManagerService: SessionUserHashManagerService
    ) {
    super(hashManagerService);
      this.endpoint += this.endpoint.endsWith("/") ? "" : "/";
    }

  public logRoute(log: logRouteRequest) {
    let options = {};
    if (localStorage.getItem('currentUser')) {
      options = this.prepareOptions(log)
    } else {
      options = this.prepareAnonymousOptions(log)
    }
    return this.httpClient.post(this.endpoint + 'api/RouteLog/Log', 
    log,
    options
    ).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('logRoute'))
    );
  }

}
